import jQuery from 'jquery'
import 'jquery-smooth-scroll'

export default class ScrollToActive {
  constructor () {
    //prevent auto scroll to on empty # troughout the site
    jQuery("a[href=\\#]").attr("href","javascript:void(0)");

    var scrollnow = function(e) {
      // if scrollnow()-function was triggered by an event
      let offset = -100;
      let hash = this ? this.hash : location.hash
      let target = hash
      
      if (document.getElementById(hash.replace('#', '')) != undefined) {

        [...document.querySelectorAll('.js-scroll')].forEach(item => {
          item.classList.remove('active')
        })

        document.querySelector(`.js-scroll[href="${target}"]`).classList.add('active')

        jQuery.smoothScroll({
          offset: offset,
          scrollTarget: target,
        });
      }
      else {
        return
      }
    };

    // if page has a #hash
    if (location.hash) {
      // smooth-scroll to hash
      setTimeout(function() {
        scrollnow();
      },500)
    }

    // for each <a>-element that contains a "/" and a "#"
    jQuery('a[href*="/"][href*="#"]').each(function(){
      // if the pathname of the href references the same page
      if (this.pathname.replace(/^\//,'') == location.pathname.replace(/^\//,'') && this.hostname == location.hostname) {
        // only keep the hash, i.e. do not keep the pathname
        jQuery(this).attr("href", this.hash);
      }
    });

    // select all href-elements that start with #
    // including the ones that were stripped by their pathname just above
    jQuery('a.js-scroll').on('click', (scrollnow));

    // on user scrolling in window function
    jQuery(window).scroll(function() {
      var scrollDistance = jQuery(window).scrollTop();
    
      // Assign active class to anchorlinks while scrolling past corresponding page-sections
      jQuery('[id*="section-"]').each(function(i) {
      var top = jQuery(this).position().top - document.querySelector('.hero').clientHeight/3
        if (top <= scrollDistance) {
          jQuery('.js-scroll').removeClass('active');
          jQuery('.js-scroll').eq(i).addClass('active');
        }
      });
      // if scrolled back to top remove active state from anchorlinks
      if ( scrollDistance == 0 ) {
        jQuery('.js-scroll').removeClass('active');
      }
    })
  }
}
